<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="jps-selection-modal"
      :no-header="!_title"
      :dialog-width="props.dialogWidth"
    >
      <template #header>
        <BaseIcon size="size-6" v-if="_icon" :name="_icon" />
        {{ ls(_title) }}
      </template>
      <div class="jps-modal-content">
        <p v-if="message">{{ ls(message) }}</p>
        <table class="jps-table">
          <tbody>
            <tr v-for="option in _options" :key="option.option">
              <td v-if="hasThumbnail">
                <BaseImage :src="option.option" />
              </td>
              <td>
                <button
                  class="jps-button"
                  @click="select(option.option)"
                  :disabled="option.disabled"
                >
                  {{ ls(option.label) }}
                </button>
              </td>
              <td>{{ ls(option.description) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.cancel) }}</button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { BaseModal } from '#components'
import type { SVG_NAMES } from '~/components/icons'

const { ls } = useI18n()

interface Options {
  title?: LangString
  icon?: SVG_NAMES
  message?: LangString
  options?: SelectionOption[]
}

interface SelectionOption {
  label: LangString;
  disabled?: boolean;
  thumbnail?: string;
  description: LangString;
  option: any;
}

interface Props {
  title?: LangString
  icon?: SVG_NAMES
  message?: LangString
  options?: SelectionOption[]
  dialogWidth?: string
}
const props = withDefaults(defineProps<Props>(), {})

const modal = ref<InstanceType<typeof BaseModal>>()
const _title: Ref<LangString> = ref()
const _icon: Ref<SVG_NAMES> = ref()
const _message: Ref<LangString> = ref()
const _options: Ref<SelectionOption[]> = ref([])
const openAwait = async (options?: Options) => {
  setOptionsValue(_title, 'title', props, options)
  setOptionsValue(_icon, 'icon', props, options)
  setOptionsValue(_message, 'message', props, options)
  setOptionsValue(_options, 'options', props, options)
  return await modal.value.openAwait<any>()
}
defineExpose({ openAwait })

const hasThumbnail = computed(() => {
  return _options.value.length > 0 && _options.value[0].thumbnail
})

const select = (n: any) => {
  if (n == null) {
    modal.value.reject()
  } else {
    modal.value.resolve(n)
  }
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-selection-modal {
  .jps-button {
    width: 100%;
  }
}
</style>
